/**
 * Slide-out product drawer for collection grid cards.
 *
 * Enabled per-section via the "Enable quick-view drawer" setting
 * (sections/template--collection.liquid -> data-drawer-enabled on
 * .grid-view-item, see snippets/grid-view-item.liquid).
 *
 * On the curated/prebuilt collection (sticky bar present):
 * - Clicking a product card or "What's in the box" opens the drawer
 * - The card is highlighted and the sticky bar appears
 * - The product is not added to cart until Subscribe or Add-ons
 * On other collections, clicking the card opens the drawer.
 */
(function () {
  var drawer = document.getElementById('ProductDrawer');
  var overlay = document.getElementById('ProductDrawerOverlay');
  var scrollEl = document.getElementById('ProductDrawerScroll');
  var body = document.getElementById('ProductDrawerBody');
  var footer = document.getElementById('ProductDrawerFooter');

  if (!drawer || !overlay || !scrollEl || !body || !footer) return;

  var EXCLUDED_SELECTOR = [
    'form',
    'button',
    'input',
    'label',
    '.quick-add-wrapper',
    '.quick-add-button-variants-custom',
    '.sold-out-button',
    '.js-whats-in-the-box'
  ].join(', ');

  var lastFocusedEl = null;
  var lastCart = null;
  var selectedCard = null;
  var prebuiltMode = !!document.querySelector('[data-custom-prebuilt-sticky-bar]');

  function initCarousel() {
    var carousel = body.querySelector('.product-drawer__carousel');
    if (!carousel) return;

    var track = carousel.querySelector('.product-drawer__carousel-track');
    var slides = carousel.querySelectorAll('.product-drawer__slide');
    var dots = carousel.querySelectorAll('.product-drawer__dot');
    var prevBtn = carousel.querySelector('.product-drawer__arrow--prev');
    var nextBtn = carousel.querySelector('.product-drawer__arrow--next');
    var index = 0;

    if (!track || slides.length <= 1) return;

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(index - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(index + 1);
      });
    }

    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(dotIndex);
      });
    });
  }

  function updateDrawerPrice(form) {
    var select = form.querySelector('[data-drawer-frequency]');
    var priceEl = form.querySelector('[data-drawer-price]');
    if (!select || !priceEl) return;

    var option = select.options[select.selectedIndex];
    if (!option) return;

    var price = option.getAttribute('data-price');
    if (price) priceEl.textContent = price;
  }

  function updateDrawerLabel(form) {
    var select = form.querySelector('[data-drawer-frequency]');
    var labelEl = form.querySelector('[data-drawer-atc-label]');
    if (!select || !labelEl) return;

    labelEl.textContent = select.value ? 'Subscribe' : 'Add to cart';
  }

  function normalizeFrequencyLabel(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function persistPrebuiltFrequency(label) {
    var normalized = normalizeFrequencyLabel(label);
    if (!normalized) return '';

    document.documentElement.setAttribute('data-prebuilt-frequency', normalized);
    try {
      sessionStorage.setItem('sea2table:prebuiltFrequency', normalized);
    } catch (err) {
      /* private mode / blocked storage */
    }
    return normalized;
  }

  function hydrateFrequencyFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return persistPrebuiltFrequency(
        params.get('frequency') || params.get('prebuilt_frequency'),
      );
    } catch (err) {
      return '';
    }
  }

  function getPrebuiltFrequencyPreference() {
    var fromDom = normalizeFrequencyLabel(
      document.documentElement.getAttribute('data-prebuilt-frequency'),
    );
    if (fromDom) return fromDom;

    try {
      return normalizeFrequencyLabel(sessionStorage.getItem('sea2table:prebuiltFrequency'));
    } catch (err) {
      return '';
    }
  }

  hydrateFrequencyFromUrl();

  function applyPrebuiltFrequencyPreference(select) {
    if (!select) return false;

    var preferred = getPrebuiltFrequencyPreference();
    if (!preferred) return false;

    for (var i = 0; i < select.options.length; i++) {
      var option = select.options[i];
      var label = normalizeFrequencyLabel(
        option.getAttribute('data-frequency-label') || option.textContent,
      );
      if (!label) continue;

      if (
        label === preferred ||
        label.indexOf(preferred) !== -1 ||
        preferred.indexOf(label) !== -1
      ) {
        select.selectedIndex = i;
        return true;
      }
    }

    return false;
  }

  function parseSellingPlans(card) {
    try {
      return JSON.parse(card.getAttribute('data-selling-plans') || '[]');
    } catch (err) {
      return [];
    }
  }

  function getSellingPlanId(card) {
    var plans = parseSellingPlans(card);
    if (!plans.length) return '';

    var preferred = getPrebuiltFrequencyPreference();
    if (!preferred) return plans[0].id || '';

    for (var i = 0; i < plans.length; i++) {
      var label = normalizeFrequencyLabel(plans[i].label);
      if (
        label === preferred ||
        label.indexOf(preferred) !== -1 ||
        preferred.indexOf(label) !== -1
      ) {
        return plans[i].id;
      }
    }

    return plans[0].id || '';
  }

  function cardIdentifiers(card) {
    return [
      card.getAttribute('data-product-key'),
      card.getAttribute('data-variant-id'),
      card.getAttribute('data-product-id'),
      card.getAttribute('data-product-handle'),
    ]
      .filter(Boolean)
      .map(function (value) {
        return String(value);
      });
  }

  function cartItemIdentifiers(item) {
    return [
      item.product_id,
      item.variant_id,
      item.id,
      item.handle,
      item.product_handle,
    ]
      .filter(function (value) {
        return value != null && value !== '';
      })
      .map(function (value) {
        return String(value);
      });
  }

  function highlightCartItems(cart) {
    if (!cart) return;
    lastCart = cart;

    var ids = {};
    (cart.items || []).forEach(function (item) {
      cartItemIdentifiers(item).forEach(function (id) {
        ids[id] = true;
      });
    });

    document.querySelectorAll('.grid-view-item[data-product-key], .grid-view-item[data-variant-id]').forEach(function (card) {
      var inCart = cardIdentifiers(card).some(function (id) {
        return !!ids[id];
      });
      card.classList.toggle('is-in-cart', inCart);
    });
  }

  function isCardInCart(card, cart) {
    var cardIds = cardIdentifiers(card);
    return (cart.items || []).some(function (item) {
      var itemIds = cartItemIdentifiers(item);
      return cardIds.some(function (id) {
        return itemIds.indexOf(id) !== -1;
      });
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
  }

  function markSelectedCard(card) {
    if (!card) return;
    selectedCard = card;
    document.dispatchEvent(new CustomEvent('prebuilt:product-selected', { detail: { card: card } }));
  }

  function addPrebuiltCardToCart(card) {
    if (!card) return Promise.resolve();
    if (card.getAttribute('data-product-available') === 'false') {
      return Promise.reject(new Error('unavailable'));
    }

    var variantId = card.getAttribute('data-variant-id') || card.getAttribute('data-product-id');
    if (!variantId) return Promise.resolve();

    return fetchCart().then(function (cart) {
      if (isCardInCart(card, cart)) {
        highlightCartItems(cart);
        return cart;
      }

      var payload = {
        id: Number(variantId),
        quantity: 1,
      };
      var sellingPlanId = getSellingPlanId(card);
      if (sellingPlanId) payload.selling_plan = sellingPlanId;

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.status) {
            throw new Error(data.description || 'Unable to add to cart');
          }
          document.dispatchEvent(new CustomEvent('product-drawer:added-to-cart', { detail: data }));
          card.classList.add('is-in-cart');
          return fetchCart().then(function (nextCart) {
            highlightCartItems(nextCart);
            return nextCart;
          });
        });
    });
  }

  function goToCheckout() {
    var checkoutForm = document.querySelector('[data-sticky-bar-checkout-form]');
    if (checkoutForm) {
      checkoutForm.submit();
      return;
    }

    window.location.href = '/checkout';
  }

  function initAtcForm() {
    var form = footer.querySelector('.product-drawer__atc-form');
    if (!form) return;

    var select = form.querySelector('[data-drawer-frequency]');
    var sellingPlanInput = form.querySelector('[data-drawer-selling-plan]');
    var submitButton = form.querySelector('[data-drawer-atc-submit]');
    var submitLabel = form.querySelector('[data-drawer-atc-label]');
    var statusEl = form.querySelector('[data-drawer-atc-status]');

    if (select) {
      applyPrebuiltFrequencyPreference(select);

      select.addEventListener('change', function () {
        if (sellingPlanInput) sellingPlanInput.value = select.value;
        updateDrawerPrice(form);
        updateDrawerLabel(form);
      });

      if (sellingPlanInput) sellingPlanInput.value = select.value;
      updateDrawerPrice(form);
      updateDrawerLabel(form);
    }

    var originalLabel = submitLabel ? submitLabel.textContent : '';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (submitButton) submitButton.classList.add('is-loading');
      if (statusEl) {
        statusEl.textContent = '';
        statusEl.classList.remove('is-error');
      }

      fetch(form.getAttribute('action') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.status) {
            if (statusEl) {
              statusEl.textContent = data.description || 'Something went wrong. Please try again.';
              statusEl.classList.add('is-error');
            }
            return;
          }

          if (submitLabel) {
            submitLabel.textContent = 'Added!';
            setTimeout(function () {
              submitLabel.textContent = originalLabel;
            }, 1500);
          }

          document.dispatchEvent(new CustomEvent('product-drawer:added-to-cart', { detail: data }));

          var stickyBar = document.querySelector('[data-custom-prebuilt-sticky-bar]');
          if (stickyBar) {
            closeDrawer();
            if (selectedCard) selectedCard.classList.add('is-in-cart');
            fetchCart().then(highlightCartItems);
          } else if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
            try {
              window.Rebuy.SmartCart.show();
            } catch (err) {
              /* no-op: fall back to inline "Added!" feedback above */
            }
          }
        })
        .catch(function () {
          if (statusEl) {
            statusEl.textContent = 'Something went wrong. Please try again.';
            statusEl.classList.add('is-error');
          }
        })
        .then(function () {
          if (submitButton) submitButton.classList.remove('is-loading');
        });
    });
  }

  function openDrawer(template) {
    var content = template.content.cloneNode(true);
    var footerContent = content.querySelector('.js-product-drawer-footer');
    if (footerContent && footerContent.parentNode) {
      footerContent.parentNode.removeChild(footerContent);
    }

    body.innerHTML = '';
    body.appendChild(content);

    footer.innerHTML = '';
    footer.hidden = false;
    if (footerContent) footer.appendChild(footerContent);

    scrollEl.scrollTop = 0;

    initCarousel();
    initAtcForm();

    lastFocusedEl = document.activeElement;

    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('product-drawer-open');

    var closeButton = drawer.querySelector('.product-drawer__close');
    if (closeButton) closeButton.focus();

    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('product-drawer-open');

    document.removeEventListener('keydown', onKeydown);

    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
      lastFocusedEl.focus();
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      closeDrawer();
    }
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.product-drawer__close') || event.target === overlay) {
      closeDrawer();
      return;
    }

    var whatsInBox = event.target.closest('.js-whats-in-the-box');
    if (whatsInBox) {
      var infoCard = whatsInBox.closest('.grid-view-item[data-drawer-enabled="true"]');
      var infoTemplate = infoCard && infoCard.querySelector('.js-product-drawer-data');
      if (!infoTemplate) return;
      event.preventDefault();
      event.stopPropagation();
      if (prebuiltMode) markSelectedCard(infoCard);
      openDrawer(infoTemplate);
      return;
    }

    var card = event.target.closest('.grid-view-item[data-drawer-enabled="true"]');
    if (!card) return;

    if (event.target.closest(EXCLUDED_SELECTOR)) return;

    var template = card.querySelector('.js-product-drawer-data');
    if (!template) return;

    event.preventDefault();
    if (prebuiltMode) markSelectedCard(card);
    openDrawer(template);
  });

  fetchCart().then(highlightCartItems).catch(function () {});
  document.addEventListener('product-drawer:added-to-cart', function () {
    fetchCart().then(highlightCartItems).catch(function () {});
  });

  if (prebuiltMode) {

    document.addEventListener('rebuy:cart.change', function () {
      fetchCart().then(highlightCartItems).catch(function () {});
    });
    document.addEventListener('rebuy:cart.remove', function () {
      fetchCart().then(highlightCartItems).catch(function () {});
    });

    document.addEventListener('prebuilt:subscribe', function () {
      addPrebuiltCardToCart(selectedCard)
        .then(function () {
          window.setTimeout(goToCheckout, 200);
        })
        .catch(function () {});
    });

    document.addEventListener('prebuilt:addons', function (event) {
      var url = event.detail && event.detail.url;
      addPrebuiltCardToCart(selectedCard).then(function () {
        if (url) window.location.href = url;
      }).catch(function () {});
    });

    var grid = document.getElementById('template--collection');
    if (grid && window.MutationObserver) {
      new MutationObserver(function () {
        if (lastCart) highlightCartItems(lastCart);
      }).observe(grid, { childList: true, subtree: true });
    }
  }
})();
